var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlashesWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 973 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fffcf9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.35,38.49,19,7.51h4.55l-10.62,31Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.86,38.49l10.62-31H40l-10.62,31Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.36,38.49,52,7.51h4.55l-10.62,31Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.86,38.49l10.62-31H73l-10.62,31Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.36,38.49,85,7.51h4.56l-10.63,31Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.86,38.49l10.62-31H106l-10.63,31Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.36,38.49,118,7.51h4.55l-10.63,31Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.86,38.49l10.63-31H139l-10.62,31Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.36,38.49,151,7.51h4.55l-10.62,31Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.87,38.49l10.62-31H172l-10.62,31Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.37,38.49,184,7.51h4.55l-10.62,31Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.87,38.49l10.62-31h4.56l-10.63,31Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.37,38.49,217,7.51h4.56l-10.63,31Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.87,38.49l10.63-31h4.55l-10.63,31Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.37,38.49,250,7.51h4.55l-10.62,31Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M255.87,38.49l10.63-31h4.55l-10.62,31Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.38,38.49,283,7.51h4.55l-10.62,31Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.88,38.49l10.62-31h4.55l-10.62,31Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.38,38.49,316,7.51h4.56l-10.63,31Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M321.88,38.49l10.62-31h4.56l-10.63,31Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M338.38,38.49,349,7.51h4.55l-10.63,31Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.88,38.49l10.63-31h4.55l-10.62,31Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.38,38.49,382,7.51h4.55l-10.62,31Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M387.89,38.49l10.62-31h4.55l-10.62,31Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M404.39,38.49,415,7.51h4.55l-10.62,31Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M420.89,38.49l10.62-31h4.56l-10.63,31Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M437.39,38.49,448,7.51h4.56l-10.63,31Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M453.89,38.49l10.62-31h4.56l-10.63,31Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M470.39,38.49,481,7.51h4.55L475,38.49Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M486.89,38.49l10.63-31h4.55l-10.62,31Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M503.4,38.49,514,7.51h4.55L508,38.49Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M519.9,38.49l10.62-31h4.55l-10.62,31Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M536.4,38.49,547,7.51h4.55L541,38.49Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M552.9,38.49l10.62-31h4.56l-10.63,31Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M569.4,38.49,580,7.51h4.56L574,38.49Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M585.9,38.49l10.63-31h4.55l-10.62,31Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M602.4,38.49,613,7.51h4.55L607,38.49Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M618.91,38.49l10.62-31h4.55l-10.62,31Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M635.41,38.49,646,7.51h4.55L640,38.49Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M652.44,38.49l10.63-31h4.55L657,38.49Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M669,38.49l10.62-31h4.55l-10.62,31Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M685.45,38.49l10.62-31h4.55L690,38.49Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M702,38.49l10.62-31h4.56l-10.63,31Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M718.45,38.49l10.62-31h4.56L723,38.49Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M735,38.49l10.63-31h4.55l-10.63,31Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M751.45,38.49l10.63-31h4.55L756,38.49Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M768,38.49l10.63-31h4.55l-10.62,31Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M784.46,38.49l10.62-31h4.55L789,38.49Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M801,38.49l10.62-31h4.55l-10.62,31Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M817.46,38.49l10.62-31h4.56L822,38.49Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M834,38.49l10.62-31h4.56l-10.63,31Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M850.46,38.49l10.62-31h4.56L855,38.49Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M867,38.49l10.63-31h4.55l-10.62,31Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M883.46,38.49l10.63-31h4.55L888,38.49Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M900,38.49l10.62-31h4.55l-10.62,31Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M916.47,38.49l10.62-31h4.55L921,38.49Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M933,38.49l10.62-31h4.55l-10.62,31Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M949.47,38.49l10.62-31h4.56L954,38.49Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlashesWhite);
export default __webpack_public_path__ + "static/media/SlashesWhite.f558ff3ee9c9d5c571002489a216fb3a.svg";
export { ForwardRef as ReactComponent };